module.exports = __webpack_public_path__ + "img/pr-46.83dbeb9c.png";